import React, { Component } from 'react'
import { findExtension,isModel, checkNotUndefindeNull } from '../../../../Templates/functions'
import { cloneDeep, isEmpty, isEqual} from 'lodash'
import _uniqueId from 'lodash/uniqueId';
import {trashAnnotationIcon, addAnnotationIcon ,saveAnnotationIcon, cancelAnnotation}from '../../../../Templates/icons';


export default class ModelAnnotationContainter extends Component {

state = {
    annotations:null,
    selectedAnnotation: null,
    existingAnnotationClicked: false,
    AnnotationMode: "view",
    DeleteAnnotationActive:false,
    Pointer:"circle",
    AnnotationArray: [],
    AnnotationCount:0,
    AnnotationText : "",
    modelsLoaded:false,
    AnnotationName: "",
    WebglAnnotationList: [],
    listSent:false
}

////////MOVED
componentDidMount =() =>{
    this.setEventListener();
    this.checkIfAttachmentHasAnnotationArray();
    this.createAnnotationArray(null);
    //this.sendlist();
   // this.setUnityCameraEventListener();
   // console.log("step info")
   // console.log(this.props)
}

/////MOVED
componentDidUpdate(prevProps) {
    this.checkIfAttachmentHasAnnotationArray();
    if(!isEqual(this.props.selectedStep, prevProps.selectedStep)) // Check if it's a new user, you can also use some unique property, like the ID  (this.props.user.id !== prevProps.user.id)
    {
        this.setEventListener();
        this.createAnnotationArray(null);
        this.setUnityCameraEventListener();
        this.cancelNewAnnotation();
        //this.sendlist();
    }

    if(!isEqual(this.props.unityContextRef, prevProps.unityContextRef)) // Check if it's a new user, you can also use some unique property, like the ID  (this.props.user.id !== prevProps.user.id)
    {
        this.setUnityCameraEventListener();
        this.cancelNewAnnotation();
    }
    
} 

////MOVED
componentWillUnmount= ()=>{
    this.unsetEventListener();
    // console.log("leaving")
    // console.log("this.state.selectedAnnotation")
    // console.log(this.state.selectedAnnotation)
    // console.log("this.state.unityContextRef")
    // console.log(this.state.unityContextRef)
    if (this.state.selectedAnnotation != null ){
        // console.log("leaving2")
        this.props.removeAnnotationFromScreen(this.state.selectedAnnotation.Anno_id)
        
         this.props.unityContextRef.send("Manager","SetRemoveAnnotation",this.state.selectedAnnotation.Anno_id)
     }
    //this.removeAnnotationPointer();
}

//////MOVED
checkIfAttachmentHasAnnotationArray =() => {
    let selectedStepClone = cloneDeep(this.props.selectedStep)
    let attachments = selectedStepClone.attachments  
    const currentAttachment = attachments[this.props.attachmentIndex || 0]  
    if(attachments.length >0 && !checkNotUndefindeNull(currentAttachment.annotations)){
        currentAttachment.annotations = [];
        attachments[this.props.attachmentIndex || 0] = currentAttachment
        selectedStepClone.attachments = attachments
        console.log("step that i updated with annotations array")
        console.log(selectedStepClone)
        let steps = this.props.updateStep(selectedStepClone)
        this.props.updateSteps(steps, selectedStepClone);
    }
  
}

  
/////////MOVED
setUnityCameraEventListener =() =>{
    if (this.props.unityContextRef != null){

        //this.props.unityContextRef.send("Manager","ToggleClickAnnotations",1)
        
     this.props.unityContextRef.on("modelsLoaded", () => {
         this.setState({modelsLoaded: true});
         console.log("model has loaded from container");
         this.sendlist();
        })

        this.props.unityContextRef.on("storeCameraData", (cameraData) => {
            
            let pasredCameraData = JSON.parse(cameraData);   
            let SelectedAnnotationClone = cloneDeep(this.state.selectedAnnotation);
            if(SelectedAnnotationClone != null){
                let state = JSON.parse(SelectedAnnotationClone.state) 
                SelectedAnnotationClone.camera_position = this.convertCameraData(pasredCameraData.position);
                SelectedAnnotationClone.camera_rotation = this.convertCameraData(pasredCameraData.rotation);//orgCameraData
                state.orgCameraData = cameraData
                SelectedAnnotationClone.state = JSON.stringify(state)
                this.setState({selectedAnnotation : SelectedAnnotationClone});
            }
       
        
        
        
        });
        this.props.unityContextRef.on("storeAnnotationData", (AnnotationData) => {
           // alert("i got something in the store annotation data");
            console.log("annotation data");
            console.log(AnnotationData);
            //this.addAnnotation(AnnotationData); 
        })
        this.props.unityContextRef.on("storeClickedAnnotation", (AnnotationData) => {
            //alert("i got something in the store click annotation data")
            console.log("annotation click data")
            console.log(AnnotationData)
        })
        this.props.unityContextRef.on("storeCreatedAnnotation", (AnnotationData) => {
           // alert("i got something in the store created annotation data")
            console.log("annotation created data")
            console.log(AnnotationData)
            this.addAnnotation(AnnotationData); 
        })
        this.props.unityContextRef.on("storeDeletedAnnotation", (AnnotationData) => {
           // alert("i got something in the store deleted annotation data")
            console.log("annotation deleted data")
            console.log(AnnotationData)
            let data = JSON.parse(AnnotationData)
            this.deleteAnnotationFromWebgl(data.id)
            
        })

    }

}

///////FUNCTION NOT NEEDED
// cancelNewAnnotation =() =>{ 
//     if (this.state.AnnotationMode === "new"){
//         this.props.unityContextRef.send("Manager","SetRemoveAnnotation", this.state.selectedAnnotation.Anno_id)
//     }
//     this.setState({selectedAnnotation: null, AnnotationMode: "view", AnnotationName: "",existingAnnotationClicked: false})
//     this.removeAnnotationPointer();
//     this.removeSelectedAnnotationClass();
// }

///////MOVED
convertCameraData =(data) =>{
    let cameraDataString = data.x.toString() + ", " + data.y.toString() + ", " + data.z.toString()
    return cameraDataString
}

////MOVED
convertRotationData =(data) =>{
    let cameraDataString = data.w.toString() + ", " + data.x.toString() + ", " + data.y.toString() + ", " + data.z.toString()
    return cameraDataString
}

//////MOVED
unsetEventListener =() =>{
    let display = document.getElementById("webGL-window")
    {display? display.removeEventListener("click",this.updateCamerandMousePosition): console.log("Unable to unset click listener for webgl")}
    {display? display.style.removeProperty("position"): console.log("Unable to remove positon to absolute for webgl")}
    if (this.props.unityContextRef != null){
        //this.props.unityContextRef.send("Manager","ToggleClickAnnotations",0)
    }
 //   console.log("annotation click event listener removed")
}

////////MOVED
setEventListener =() =>{
    let display = document.getElementById("webGL-window")
    {display? display.addEventListener("click",this.updateCamerandMousePosition): console.log("Unable to set click listener for webgl")}
    {display? display.style.setProperty("position","absolute"): console.log("Unable to set positon to absolute for webgl")}
    
}

/////MAYBE?
updateCamerandMousePosition =(event)=>{     
    if(this.props.toggleAnnotation && this.state.selectedAnnotation != null){
        let selectedAnnotationClone = cloneDeep(this.state.selectedAnnotation)
        let coords = this.convertMousePoistionGrid(event.layerX , event.layerY, "center")
        selectedAnnotationClone.x = coords.x 
        selectedAnnotationClone.y = coords.y
        this.setState({selectedAnnotation: selectedAnnotationClone})  
        let offset = 17;
        {this.state.Pointer == "point"? offset = 7 : offset = 17}
        // console.log("off")
         // +255
        //this.drawPointer(coords.x - offset,coords.y + offset)
        //this.getCameraPosition(false);
    }
}

/////MAYBE?
convertMousePoistionGrid =(x,y,style)=>{
    let displayWidth = document.getElementById("webGL-window").clientWidth;
    let displayHeight = document.getElementById("webGL-window").clientHeight;
    let centerX = displayWidth / 2;
    let centerY = displayHeight / 2;
    let coords = {x:0,y:0}
    if(style == "center"){
        if (x != centerX){       
            coords.x = x - centerX;        
        }
        if(y != centerY){
            coords.y = centerY - y;
        }
    }
    else{
        if (x != centerX){
            coords.x = centerX + x;             
        }
        else{coords.x = centerX}
        if(y != centerY){           
            coords.y = centerY - y ;
        }
        else{coords.y = centerY}
    }
    return coords;
}

/////MAYBE?
updatePointer =(pointer) =>{
    let selectedAnnotationClone = cloneDeep(this.state.selectedAnnotation)
    selectedAnnotationClone.pointer = pointer
    this.setState({selectedAnnotation: selectedAnnotationClone , Pointer: pointer})
    this.drawPointer(this.state.selectedAnnotation.x, this.state.selectedAnnotation.y)
}

/////MAYBE?
removeSelectedAnnotationClass =() =>{
  let oldSelectedDiv = document.getElementsByClassName("selectedAnnotation")
    if(typeof oldSelectedDiv != "undefined" && oldSelectedDiv != null && oldSelectedDiv.length != 0){
        oldSelectedDiv[0].classList.remove("selectedAnnotation")
    }
}

//////MOVED
setSelectedAnnotation = (e,annotation ,id) =>{
    if(e != null)
        e.stopPropagation()

    this.removeSelectedAnnotationClass();
    console.log("annotation")
     let newSelectedDiv = document.getElementById(id)
    if(typeof newSelectedDiv != "undefined" && newSelectedDiv != null){
        console.log("adding class")
        newSelectedDiv.classList.add("selectedAnnotation")
    }
    let state = JSON.parse(annotation.state)
 
    this.setState(
        {AnnotationMode : "view", 
        selectedAnnotation: annotation, 
        DeleteAnnotationActive: true, 
        Pointer: annotation.pointer , 
        AnnotationText: annotation.message || "",
         AnnotationName: state.name ,
        existingAnnotationClicked: true
        },() => this.setSelectedAnnotationPartTwo(annotation))
  
    //this.drawPointer(annotation.x,annotation.y,annotation.pointer)
    //this.getCameraPosition(state.orgCameraData)
}

setSelectedAnnotationPartTwo=(annotation)=>{
    
    console.log("setting thi anno@@@@@")
    console.log(this.state.selectedAnnotation)
    console.log(annotation)
      if(checkNotUndefindeNull(this.state.selectedAnnotation) && this.state.selectedAnnotation.Anno_id == annotation.Anno_id){
            console.log("setting thi anno@")
        this.props.unityContextRef.send("Manager","ShowAnnotation",annotation.Anno_id)
        this.props.unityContextRef.send("Manager","LookAtAnnotation",annotation.Anno_id)
        this.clickOnAnnotation(annotation.Anno_id);
       }

}

//////MOVERD
makeid(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * 
 charactersLength));
   }
   return result;
}

///////MOVED
createAnnotation =()=>{
    let randString = this.makeid(15)
    let id = _uniqueId(`${randString}-`)
    let name = this.createAnnotationName()
    let displayWidth = document.getElementById("webGL-window").clientWidth;
    let displayHeight = document.getElementById("webGL-window").clientHeight;
    let NewAnnotation ={
        Anno_id : id,
        background_color: "#ffffff",
        state: JSON.stringify({name:name,canvasWidth: displayWidth, canvasHeight:displayHeight, orgCameraData:{} }),
        message: "",
        camera_position: "",
        camera_rotation: "", 
        x: 0,
        y: 0,
        pointer: "circle"
    }
    //this.createAnnotationName();
    this.removeSelectedAnnotationClass();
    this.setState({AnnotationMode : "new",selectedAnnotation: NewAnnotation, Pointer: "circle", AnnotationText:"", AnnotationName: name,existingAnnotationClicked: false});

}

///////MOVED
addAnnotation = (data) =>{
    let anno_array = cloneDeep(this.state.AnnotationArray)
    let name = this.createAnnotationName();
    let displayWidth = document.getElementById("webGL-window").clientWidth;
    let displayHeight = document.getElementById("webGL-window").clientHeight;
    let parsedData = JSON.parse(data)
    console.log("data from annotation")
    console.log(parsedData)
    let newAnnotation =  {
         Anno_id : parsedData.id,
         background_color: "#ffffff",
         state: JSON.stringify({name:name,canvasWidth: displayWidth, canvasHeight:displayHeight, orgCameraData:data, scale:parsedData.scale }),
         message: parsedData.text,
         camera_position: this.convertCameraData(parsedData.position),
         camera_rotation: this.convertRotationData(parsedData.cameraRotation), 
         x: 0,
         y: 0,
         pointer: "circle"}
 
     anno_array.push(
         <div id={parsedData.id} className={"AnnotationDivs clickable"} key ={newAnnotation.Anno_id} onClick={ () => this.clickOnAnnotation(newAnnotation.Anno_id)}>
                    
             <div className={"rstcustom__rowLabel"}>
                 <span className={"rstcustom__rowTitle"}>{name}</span>    
             </div>          
         </div>
     )
     this.removeSelectedAnnotationClass();
    this.setState({AnnotationMode : "new",selectedAnnotation: newAnnotation, Pointer: "circle", AnnotationText:parsedData.text, AnnotationName: name,existingAnnotationClicked: false});

    // this.setState({AnnotationArray: anno_array})
}

//////MOVED
clickOnAnnotation =(id) =>{
    //alert(id)
    if(!this.state.listSent){
        console.log("clicking from ClICKONAnnOTATION")
        this.sendlist();
        this.setState({listSent:true})
        console.log("test1")
        setTimeout(()=>{this.props.unityContextRef.send("Manager","LookAtAnnotation",id)},100)
    }
    else{
        this.props.unityContextRef.send("Manager","LookAtAnnotation",id)
    }
     
}

//////////MOVED
saveNewAnnotation=()=>{
    //this.updatePointer()
    let selectedStepClone = cloneDeep(this.props.selectedStep)
    if(this.state.existingAnnotationClicked){
        let annotations = selectedStepClone.attachments[this.props.attachmentIndex].annotations
        annotations.forEach(annotation => {
            if (annotation.Anno_id == this.state.selectedAnnotation.Anno_id){
               let str =  JSON.parse(annotation.state)
               str.name = this.state.AnnotationName
               annotation.state = JSON.stringify(str)
               annotation.message = this.state.AnnotationText
            }
        })
        selectedStepClone.attachments[this.props.attachmentIndex].annotations = annotations
    }else{  
    selectedStepClone.attachments[this.props.attachmentIndex].annotations.push(this.state.selectedAnnotation)  
    }
    let steps = this.props.updateStep(selectedStepClone)
    this.props.updateSteps(steps, selectedStepClone); 
    this.setState({AnnotationMode : "view"})
    this.createAnnotationArray(selectedStepClone);
    this.sendlist();
}

////////MOVED
deleteAnnotation = () =>{
   // if(window.confirm("You are able to detele this annotation. Are you sure you want to continue?")){
        //this.updatePointer()
        let selectedStepClone = cloneDeep(this.props.selectedStep)
        //if no annotations, don't perform deletion
        if(selectedStepClone.attachments && selectedStepClone.attachments[this.props.attachmentIndex]) {
            let attachment = selectedStepClone.attachments[this.props.attachmentIndex];
            if(attachment.annotations && attachment.annotations.length !== 0){
                console.log("Deleteing this annotation")
                console.log(this.state.selectedAnnotation)
                let annotations = selectedStepClone.attachments[this.props.attachmentIndex].annotations
                let filteredAnnotations =  annotations.filter(annotation => annotation.Anno_id != this.state.selectedAnnotation.Anno_id)
                let anno = annotations.filter(annotation => annotation.Anno_id == this.state.selectedAnnotation.Anno_id)
                let annotext = anno[0].message
        
                let regExp = new RegExp('\\&lt;Annotation,(.*?),(.*?),(.*?).&gt;','g')
                let matchesAll = [...selectedStepClone.content.matchAll(regExp)]
                let replacementText = ""
                if(null != matchesAll && matchesAll.length > 0){
                    console.log("INSIDE THE MATCHES")
                    for(let i = 0; i < matchesAll.length; i++){
                        if(matchesAll[i][1] == this.state.selectedAnnotation.Anno_id){
                            console.log("INSIDE THE MATCHES2")
                        replacementText = matchesAll[i][3];
                        let spanText = replacementText
                        selectedStepClone.content = selectedStepClone.content.replace(matchesAll[i][0],spanText)
                    }
                    }
                }
            
                console.log("TRYING TO DELETE CONTENT AFTER")
                console.log(selectedStepClone)
                this.props.unityContextRef.send("Manager","SetRemoveAnnotation", this.state.selectedAnnotation.Anno_id)
                selectedStepClone.attachments[this.props.attachmentIndex].annotations = filteredAnnotations           
                let steps = this.props.updateStep(selectedStepClone)
                this.props.updateSteps(steps, selectedStepClone, false,false,this.props.selectedStepIsChild, false); 
            // this.props.updateSelectedStep(selectedStepClone)
                this.setState({AnnotationMode : "view", AnnotationText: ""},()=>{
                    this.createAnnotationArray(selectedStepClone);
                    //this.sendlist();
        
                })
            }
        }
        

   // }
}

checkIfSelectedAnnotation=(annotation)=>{
if((checkNotUndefindeNull(this.state.selectedAnnotation) && (this.state.selectedAnnotation.Anno_id == annotation.Anno_id)))
{
    return true
}
else{return false}

}

//////MOVED
deleteAnnotationFromWebgl = (annotationID) =>{
    // if(window.confirm("You are able to detele this annotation. Are you sure you want to continue?")){
         //this.updatePointer()
         let selectedStepClone = cloneDeep(this.props.selectedStep)
         let annotations = selectedStepClone.attachments[this.props.attachmentIndex].annotations
         let filteredAnnotations =  annotations.filter(annotation => annotation.Anno_id !== annotationID)
         let anno = annotations.filter(annotation => annotation.Anno_id == annotationID)
         let annotext = anno.message
         let textToRemove = `<Annotation,${annotationID},${this.props.attachmentIndex},${anno.message}.>`
         console.log("TRYING TO DELETE CONTENT")
         console.log(selectedStepClone)
         if(selectedStepClone.content.contains(textToRemove)){
            console.log("the replacement was in the content")
            selectedStepClone.content = selectedStepClone.content.replace(textToRemove,anno.message)
         }  
         selectedStepClone.content = selectedStepClone.content.replace(textToRemove,anno.message)      
         console.log("TRYING TO DELETE CONTENT AFTER")
         console.log(selectedStepClone)

         selectedStepClone.attachments[this.props.attachmentIndex].annotations = filteredAnnotations           
         let steps = this.props.updateStep(selectedStepClone)
         this.props.updateSteps(steps, selectedStepClone); 
       //  this.props.updateSelectedStep(selectedStepClone)
         this.setState({AnnotationMode : "view", AnnotationText: ""})
         this.createAnnotationArray(selectedStepClone);
       //  this.sendlist();
    // }
 }

///////MOVED
createAnnotationArray =(stepAfterDelete) =>{
    
    let attachments =  null; 
    if(checkNotUndefindeNull(stepAfterDelete)){
        attachments = stepAfterDelete.attachments
    }else{
        attachments = this.props.selectedStep.attachments 
    }       
    let anno_array = [];
    let count = 1;   
    let firstAnnoID = 0;
    let firstAnnotation = null
     let WebglList = []

    const currentAttachment = attachments[this.props.attachmentIndex || 0]       
    const filename = this.props.viewingAttachment || currentAttachment ? currentAttachment.path : ""       
    let ext = findExtension(filename);
    let typeModel = isModel(ext)   
    let noAnnotations =(
            <div className={"AnnotationDivs"} key={"123456"} disabled>
                <div className={"rstcustom__rowLabel"}>
                    <span className={"rstcustom__rowTitle"}>No Annotations Found</span>    
                </div>          
            </div>) 
    if (typeModel){
        // console.log("currentAttachment")
        // console.log(currentAttachment)
        if ((checkNotUndefindeNull(currentAttachment.annotations) && checkNotUndefindeNull(currentAttachment.annotations.length) && currentAttachment.annotations.length == 0) || !checkNotUndefindeNull(currentAttachment.annotations)){
            anno_array.push(noAnnotations)
            this.setState({DeleteAnnotationActive: false})
        }
        else{
           if(checkNotUndefindeNull(currentAttachment.annotations)){
            currentAttachment.annotations.forEach(annotation => {
                let id = "Annotation" + count              
                let state = ""
                if(annotation.state){
                    state = JSON.parse(annotation.state)
                }else{
                    state = {name:"Annotation"}
                }
                if(count == 1){
                    firstAnnoID = id
                    firstAnnotation = annotation
                }
                WebglList.push(JSON.parse(state.orgCameraData))
               
                let key =  _uniqueId('prefix-')
                anno_array.push(
                    <div id={id} 
                    
                    className={`AnnotationDivs clickable `}
                     key ={key} 
                     onClick={(event) => this.setSelectedAnnotation(event,annotation, id)}>
                        <div className={"rstcustom__rowLabel"}>
                            <span className={"rstcustom__rowTitle"}>{state.name || ""}</span>    
                        </div>          
                    </div>
                )
                count = count + 1
            })
        }
           ///////////////////////////////////////////////// 
        }

    }
    else{
        anno_array.push(noAnnotations)
    }
//    console.log("adding thr weblglist")
//    console.log(WebglList)
    this.setState({AnnotationArray: anno_array, WebglAnnotationList : WebglList},() => this.sendlist(WebglList,firstAnnoID,firstAnnotation))
}


///////MOVED
sendlist =(list,firstAnnoID,firstAnnotation) =>{
    let listToSend = list || this.state.WebglAnnotationList
    let newList = []
    if (checkNotUndefindeNull(this.props.unityContextRef) && this.props.modelsLoaded){
    console.log("SENDING LIST Before")
    console.log(listToSend)
     if(listToSend.length > 1){

        let first = listToSend[0];
        let last = listToSend[listToSend.length - 1]
        for(let i = 0; i<listToSend.length;i++){
            if(i == 0){
                newList.push(last)
            }
            else if(i == listToSend.length - 1){
                newList.push(first)
            }
            else{
                newList.push(listToSend[i])
            }
        }
    }
   else{
        newList = cloneDeep(listToSend)
   }

    console.log("SENDING LIST AFTER")
    console.log(newList)
    this.props.unityContextRef.send("Manager","SetAnnotations",JSON.stringify({annotationDatas:newList}))
    if(checkNotUndefindeNull(firstAnnoID) && checkNotUndefindeNull(firstAnnotation)){
        console.log("clicking the firstasfawfasd")
        console.log(firstAnnotation)
        this.setSelectedAnnotation(null,firstAnnotation,firstAnnoID) 
    }
   
    //setRemoveAnnotation
}
}

    render(){ 
           
     return   <div id="ModelAnnotationContainer" hidden={this.props.hidden}>
                <div id="AnnotationListContainter">
                    <div style={{height:"calc(100% - 30px)" , overflowY:"scroll", overflowX:"hidden"}}>
                        <div id="AnnotationListContainer"style={{height:"100%", display:"flex",flexDirection:"column"}}>
                            {this.state.AnnotationArray}
                            {/* <button onClick={this.sendlist}>send llist</button> 
                            ,background: "#5068af"
                            width:"calc(100% - .0125em)",flexDirection:"row",display:"flex"
                            */}
                        </div>
                    </div>
                        <div id={"AnnotationCreateDiv"} className="" style={{ width:"100%" ,height:"30px"}}>
                            {/* <div className="AnnotationSaveClose" style={{ marginLeft:"16px", marginTop:"13px", float:"left",borderRadius:"3px"}}>
                                {addAnnotationIcon(this.createAnnotation)}
                            </div> */}
                            <div className="AnnotationSaveClose" style={{ marginLeft:"calc(50% - 71px)", marginTop:"2.5px", float:"left",borderRadius:"3px"}}>
                                {trashAnnotationIcon(this.deleteAnnotation, this.state.DeleteAnnotationActive)}
                            </div>                                                   
                        </div>           
                </div>
            
                {/* {this.state.selectedAnnotation != null ? 
                <div id="AnnotationOptions">
                    <div style={{ height:"100%"}}>
                        <div  style={{overflowY:"scroll",height:"calc(100% - 60px)"}}>
                        {this.state.AnnotationMode == "new" || this.state.AnnotationMode == "view"? 
                            <div style={{width:"100%", textAlign:"center"}} >
                                <input value={this.state.AnnotationName} onChange={this.handleAnnotationNameChange}/> 
                            </div>:null}
                        {/* <div>
                            <div id="AnnotationPointerSelection" style={{paddingLeft:"30px"}} >
                                <input type="radio" value="Point" name="pointer" onChange={() => this.updatePointer("point")} checked={this.state.Pointer == "point"}/><span className={"AnnotationRadioButtons"} >Point</span> 
                                <input type="radio" value="Triangle" name="pointer" onChange={() => this.updatePointer("triangle")} checked={this.state.Pointer == "triangle"}/> <span className={"AnnotationRadioButtons"} >Triangle</span>
                                <input type="radio" value="Circle" name="pointer" onChange={() => this.updatePointer("circle")} checked={this.state.Pointer == "circle"} /> <span className={"AnnotationRadioButtons"} >Circle</span> 
                            </div>
                        </div>                */}
                       {/* <div>
                            <label>X:</label>
                            <p> {this.state.selectedAnnotation.x}</p>                   
                        </div>
                        <div>
                            <label>y:</label>
                            <p>{this.state.selectedAnnotation.y}</p>                   
                        </div>*/}
                        {/* <div>
                            <label>camera position:</label>
                            <p>{this.state.selectedAnnotation.camera_position}</p>                   
                        </div> */}
                        {/* <div> 
                            <label>camera rotation:</label>
                            <p>{this.state.selectedAnnotation.camera_rotation}</p>                   
                        </div>    
                        <div style={{height:"calc(100% - 102px)",paddingLeft:"30px"}}> 
                            <form style={{height:"90%"}}>
                                <textarea
                                type="text" 
                                style={{width:"calc(100% - 30px)", height:"100%", minHeight:"100px"}}
                                id="AnnotationMessageInput"  
                                placeholder="Annotation message here." 
                                onChange={this.handleAnnotationMessageChange}
                                value={this.state.AnnotationText}                        
                                /> 
                            </form>
                        </div>
                        </div>
                             <button onClick={ this.getCameraPosition} disabled={this.props.unityContextRef == null?true:false} >camera position</button>  
                        
                        <div style={{width:"calc(100% - .0125em)",flexDirection:"row",display:"flex",height:"60px", background:"rgb(80, 104, 175)",borderRadius:"0 0 1em"}} >
                           <div style={{marginLeft:"auto", marginRight:"auto"}}>
                            <div className="AnnotationSaveClose" style={{ float:"left",paddingTop:"13px"}}>{saveAnnotationIcon(this.saveNewAnnotation,false)}  </div>
                            <div className="AnnotationSaveClose" style={{ marginLeft:"20px", float:"left",paddingTop:"13px", width:"120px"}}>{cancelAnnotation(this.cancelNewAnnotation,false)}  </div>
                           </div>
                        </div>
                                                    
                        
                        

                    </div></div>:
                    <div id="AnnotationOptions">
                        <div style={{padding:"30px",height:"calc(100% - 120px)"}}>
                            Please select an Annotation or create a new one.
                        </div>
                        <div style={{width:"calc(100% - .0125em)",flexDirection:"row",display:"flex",height:"60px", background:"rgb(80, 104, 175)",borderRadius:"0 0 1em"}} >
                           <div style={{marginLeft:"auto", marginRight:"auto"}}>
                            <div disabled={true} className="AnnotationSaveClose" style={{ float:"left",paddingTop:"13px"}}>{saveAnnotationIcon(()=> console.log(),true)}  </div>
                            <div disabled={true} className="AnnotationSaveClose" style={{ marginLeft:"20px", float:"left",paddingTop:"13px", width:"120px"}}>{cancelAnnotation(()=> console.log(),true)}  </div>
                           </div>
                        </div>
                    </div>
                } */}

        </div>

    }
}
